export default __webpack_public_path__ + "static/media/google-authenticator.99fc5da0.svg";